<div class="message-container">
  <div (click)="clickMessage(msg.id,msg.idTopic)"
    *ngFor="let msg of messages; trackBy: trackById"
    class="message-box"
    [ngClass]="msg.type"
    [@slideIn]
    >
    <div class="message-content">
      <span class="icon">{{ getIcon(msg.type) }}</span>
      <span class="text">{{ msg.text }}</span>
      <button class="close-btn" (click)="remove(msg.id)">×</button>
    </div>
  </div>
</div>